import type { ExecutionPlanSummary } from '../api'

/** TASK-00300 — stable Admin summary when API omits or partially sends fields. */
export function normalizeExecutionPlanSummary(
  raw: ExecutionPlanSummary | null | undefined,
): ExecutionPlanSummary | null {
  if (!raw || typeof raw !== 'object') return null
  const total = Number(raw.total)
  const workerBacked = Number(raw.worker_backed)
  const apiBacked = Number(raw.api_backed)
  const executable = Number(raw.executable)
  if (![total, workerBacked, apiBacked, executable].every((n) => Number.isFinite(n))) {
    return null
  }
  return {
    total,
    worker_backed: workerBacked,
    api_backed: apiBacked,
    executable,
    default_display_name: raw.default_display_name ?? null,
  }
}
